// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__8GL6Y"};